import { Component, OnChanges, AfterViewInit, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { RealtorPortalService } from 'src/app/services/network/realtor-portal.service';
import { WarrantyLinkComponent } from '@ftdr/warranty-link';

@Component({
  selector: 'app-warranty-link',
  templateUrl: './warranty-link.component.html',
  styleUrls: ['./warranty-link.component.css']
})
export class WLComponent implements OnChanges, AfterViewInit {

  public rootId = 'warranty-link-root';
  private hasViewLoaded = false;
  policyId: string;
  apiUrl: string;
  brand: string;

  constructor(private route: ActivatedRoute, private realtorPortalService: RealtorPortalService) {}

// tslint:disable-next-line:typedef
  public ngOnChanges() {
    this.renderComponent();
  }
// tslint:disable-next-line:typedef
  public ngAfterViewInit() {
    this.hasViewLoaded = true;
    this.route.params.subscribe(params => {
      if (params['brand']) {
        this.brand = params['brand'];
      } else {
        this.brand = 'og';
      }
      if (params['policyId']) {
          this.policyId = params['policyId'];
          this.apiUrl = this.realtorPortalService.getWarrantyLinkUrl();
          this.renderComponent();
      }
    });
  }

  // tslint:disable-next-line:typedef
  private renderComponent() {
    if (!this.hasViewLoaded) {
      return;
    }

    ReactDOM.render(
      React.createElement(WarrantyLinkComponent, {brand: this.brand ,
      apiurl: this.apiUrl, policyid: this.policyId} ),
      document.getElementById(this.rootId)
    );
  }

}
